import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { ContractorRecollection, RecollectionType } from 'src/interfaces/contractor'
import { getOnboardingTableStepTitle } from 'src/utils/collectedData'
import { RECOLLECTION_REASON_MESSAGES } from './constants'
import { getInitiatorLabel } from './utils'

interface RecollectionTooltipContentProps {
  recollection: ContractorRecollection
}

const RecollectionTooltipContentComponent = ({ recollection }: RecollectionTooltipContentProps) => {
  const stepTitle = getOnboardingTableStepTitle(recollection.stepType)
  const typeLabel = recollection.type === RecollectionType.Manual ? 'Manual' : 'Auto Recollection'
  const initiatorLabel = getInitiatorLabel(recollection)
  const message = recollection.createReason
    ? RECOLLECTION_REASON_MESSAGES[recollection.createReason]
    : null

  return (
    <div css={tw`flex flex-col gap-1`}>
      <Typography variant="subtitle2" css={tw`text-[#B4AFC0] font-normal`}>
        {typeLabel}
        {initiatorLabel && <span css={tw`ml-1`}>· {initiatorLabel}</span>}
      </Typography>
      <Typography variant="subtitle2" css={tw`text-[#DAD9E0] font-semibold`}>
        {stepTitle}
      </Typography>
      {message && (
        <Typography variant="subtitle2" css={tw`text-[#B4AFC0] font-normal`}>
          {message}
        </Typography>
      )}
    </div>
  )
}

export const RecollectionTooltipContent = memo(RecollectionTooltipContentComponent)
